export const mobileSidebarAction = status => ({
  type: 'MOBILE_SIDEBAR',
  status,
})
